<div class="overlay2" [ngClass]="{'modeone': isModeOne, 'modetwo': isModeTwo}">
  <div class="pop2">
    <ng-container *ngIf="!displayBenefitProductDetails then bonusActionsList else benefitProductDetails">
    </ng-container>
    <ng-template #bonusActionsList>
      <ng-container
        *ngIf="!showBenefitAdditionalInformation then ShowBonusActionsList else ShowBenefitAdditionalInformation">
      </ng-container>
      <ng-template #ShowBonusActionsList>
        <div class="bonus-dialog__content">
          <header class="bonus-dialog__header">
            <h1 langkey="dialog_choose_text"></h1>
            <p langkey="benefit_no_bonus_promotions"></p>
          </header>
          <div class="bonus-dialog__list">
            <sot-scroller-vertical>
              <ng-container *ngFor="let bonusAction of bonusActions; let i = index; trackBy: trackByBonusActionId">
                <div class="bonus-action">
                  <div class="bonus-action__header">
                    <h1>{{ bonusAction.name}}</h1>
                    <div class="bonus-action__summary">
                      <div class="bonus-action__summary-title">
                        <h2 langkey="benefit_overview"></h2>
                      </div>
                      <div class="bonus-action__points">
                        <h2 class="bonus-action__points-label" langkey="benefit_label_of_your_points"></h2>
                        <h2 class="bonus-action__points-value">{{bonusAction.userAvailablePoints$ | async}}</h2>
                      </div>
                    </div>
                  </div>
                  <div class="bonus-action__basket-info">
                    <ng-container *ngIf="(bonusAction.pointsInBasket$ | async) > 0">
                      <span>{{bonusAction.pointsInBasket$ | async}} <span langkey="benefit_by"></span>
                        <span class="bonus-action__basket-total">{{bonusAction.totalUserBonusActionPoints}}</span>
                        <span langkey="benefit_redeem_points"></span>
                      </span>
                    </ng-container>
                  </div>
                  <div class="bonus-action__benefits">
                    <ng-container *ngFor="let benefit of visibleBenefits(bonusAction, i); trackBy: trackByBenefitId">
                      <div class="benefit-card" (click)="onBenefitClick(bonusAction, benefit, $event)">
                        <!-- IMG-->
                        <div *ngIf="benefit.hasImage" class="benefit-card__image">
                          <img [src]="benefit.imageUrl" class="ya_image">
                        </div>
                        <div *ngIf="!benefit.hasImage" class="benefit-card__image benefit-card__image--noimg">
                          <h3>{{benefit.name}}</h3>
                        </div>
                        <div class="benefit-card__content">
                          <div class="benefit-card__header">
                            <h2>{{benefit.name}}</h2>
                            <ng-container *ngIf="canDisplayAdditionalInformation(benefit.productID)">
                              <div class="benefit-card__info">
                                <a class="btn"
                                  (click)="toggleBenefitAdditionalInfo(true);displayAdditionalInfo(benefit.productID,$event)"><span>i</span></a>
                              </div>
                            </ng-container>
                          </div>
                          <div class="benefit-card__points">
                            <div class="benefit-card__cost">
                              <span>{{benefit.costPoints}} <span langkey="benefit_label_of_points"></span></span>
                            </div>
                            <div class="benefit-card__progress">
                              <div class="point-circle"
                                [ngClass]="
                              {'points--redeemable': canRedeem( bonusAction,benefit), 'points--progress': !canRedeem( bonusAction, benefit)}">
                                <div class="inline-icon" inlineSVG="sot/sot-icon.svg#sot-bonus"></div>
                                <!-- SVG circle -->
                                <svg viewBox="0 0 36 36" class="circular-chart">
                                  <!-- Background -->
                                  <path class="circle-bg" d="M18 2 a 16 16 0 0 1 0 32 a 16 16 0 0 1 0 -32" />
                                  <!-- Progress -->
                                  <path *ngIf="!canRedeem( bonusAction, benefit)" class="circle-progress"
                                    [attr.stroke-dasharray]="getAvailablePointsPercentage(benefit, bonusAction) + ', 100'"
                                    d="M18 2 a 16 16 0 0 1 0 32 a 16 16 0 0 1 0 -32" />
                                </svg>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="benefit-card__footer">
                          <sot-amount [amount]="getBenefitCount(bonusAction, benefit)"
                            [max]="getMaxRedeemableCount(bonusAction, benefit)"
                            (amountChange)="onBenefitAmountChange($event, bonusAction, benefit)"
                            [class.small]="true"></sot-amount>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                  <ng-container *ngIf="canDisplayShowMore(bonusAction.benefits)">
                    <div a11y_Button class="bonus-action__show-more" (click)="toggleShowMore(i)"
                      [ngClass]="{'active': isShowMore(i)}">
                      <span>{{ getToggleLabel(i) }}</span>
                    </div>
                  </ng-container>
                </div>
              </ng-container>
            </sot-scroller-vertical>
          </div>
          <footer class="buttons">
            <a class="btn goforward" (click)="closeBonusActionsView()">
              <span langkey="button_continue"></span>
              <div inlineSVG="sot/sot-icon.svg#sot-forward" flex [setSVGAttributes]="{class: 'btn-icon'}"></div>
            </a>
          </footer>
        </div>
      </ng-template>
      <!-- Additional Information -->
      <ng-template #ShowBenefitAdditionalInformation>
        <sot-productAdditionalInfo [product]="benefitProduct"
          [toggleShowInfo]="toggleBenefitAdditionalInfo.bind(this,false)">
        </sot-productAdditionalInfo>
      </ng-template>
    </ng-template>
    <!-- Single product view -->
    <ng-template #benefitProductDetails>
      <sot-product-detail-view [product]="benefitProduct"
        [canAddProductToBasket]="canRedeem(selectedBonusAction, selectedBenefit)" [requiredPoints]="selectedBenefitCost"
        [benefitImageUrl]="selectedBenefit?.imageUrl" [benefitHasImage]="selectedBenefit?.hasImage"
        (onAddToBasket)="onAddToBasket($event)" (onBack)="backToBenefitList()"></sot-product-detail-view>
    </ng-template>
  </div>